'use strict';

module.exports = {
    SIGN: 'Se connecter',
    SIGN_JOIN: 'Se connecter ou s\'inscrire gratuitement !',
    EMAIL_EXISTS: 'Ce compte existe déjà.',
    INVALID_EMAIL: 'Veuillez entrer une adresse e-mail valide',
    INVALID_FIRST_NAME: 'Veuillez entrer un prénom valide',
    INVALID_LAST_NAME: 'Veuillez entrer un nom de famille valide',
    INVALID_PASSWORD: 'Veuillez saisir entre 6 et 20 caractères (A-Z, a-z, 0-9 uniquement)',
    INVALID_REPASSWORD: 'Les mots de passe ne sont pas identiques',
    INVALID_VALID_CODE: 'Veuillez saisir un code valide',
    UNAVIALABLE_SERVICE: 'Le service n\'est pas disponible, veuillez réessayer plus tard.',
    EMPTY_VALID_CODE: 'Tapez les caractères que vous voyez dans l\'image',
    NOT_MEMBER: 'Pas encore membre ?',
    ALREADY_MEMBER: 'Déjà un membre d\'AliExpress/Alibaba?',
    EMAIL: 'Adresse mail',
    CONTACT_NAME: 'Nom du contact:',
    FIRST_NAME: 'Prénom',
    LAST_NAME: 'Prénom',
    PASSWORD: 'Mot de passe',
    REPASSWORD: 'Entrez à nouveau un mot de passe:',
    EMPTY_CODE: 'Saisissez le code affiché:',
    REFRESH: 'Actualiser',
    CREATE_MY_ACCOUNT: 'Créer compte',
    NAME: 'Nom',
    VERIFICATION: 'Code de vérification',
    AGREE_MENT: 'En créant un compte AliExpress, vous acceptez',
    AE_MEMBER_SHIP: 'Contrat d\'adhésion gratuite à AliExpress.com',
    AND: 'et',
    PRIVACY_POLICY: 'la Politique de confidentialité',
    SLIDE_SUBMIT: 'Faites glisser à droite pour vérifier',
    SLIDE_SUBMIT_TIPS: 'Succès',
    LOADING: 'Chargement…',
    SLIDE_SUBMIT_ERROR_TIPS: 'Faites glisser à droite pour vérifier',
    SHOP_NOW: 'ACHETER',
    SIGN_IN: 'Se connecter',
    REGISTER_SMS: "S'inscrire par SMS",
    REGISTER_EMAIL: "S'inscrire par e-mail",
    PHONE_NUMBER: 'Numéro de téléphone ',
    VALID_NUMBER: 'Veuillez insérer un numéro de téléphone valide',
    SEND_SMS_CODE: 'Envoyer le code SMS',
    SMS_POLICY: 'Nous enverrons un code de vérification via SMS sur le numéro de téléphone que vous avez entré. Veuillez-vous assurer que le code du pays et le numéro de téléphone sont corrects.',
    SEND_TO: 'Nous avons envoyé le code à',
    VERIFICATION_RECEIVED: 'Veuillez entrer le code de vérification reçu ou',
    EDIT_NUMBER: 'modifier le numéro',
    RESEND_CODE: 'Renvoyer le code',
    LAST_STEP: 'Dernière étape',
    SET_SIGN_IN_PASSWORD: "Définissez un mot de passe d'accès pour sécuriser votre compte.",
    INVALID_PHONE_PASSWORD: '6-20 caractères (lettres et chiffres uniquement)',
    NOT_CORRECT_CODE: 'Le code est incorrect, veuillez réessayer.',
    SAVE_PASSWORD: 'Sauvegarder le mot de passe',
    NO_RECEIVED_CODE: "Si vous n'avez pas encore reçu le code, veuillez réessayer",
    VIA_EMAIL: "S'inscrire par e-mail"
};